"use client"

import { useEffect, useState } from "react"
import type { Animal } from "@/lib/types"
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, Radar, Tooltip, Legend } from "recharts"

export function AnimalMetricsChart({ animal }: { animal: Animal }) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  const metricsData = [
    { name: "Body Length", value: animal.body_length, fullMark: 100 },
    { name: "Back Height", value: animal.back_height, fullMark: 100 },
    { name: "Chest Perimeter", value: animal.chest_perimeter, fullMark: 100 },
    { name: "Body Width", value: animal.body_width, fullMark: 100 },
    { name: "Rib Depth", value: animal.rib_depth, fullMark: 100 },
    { name: "Rump Height", value: animal.height_of_rump, fullMark: 100 },
  ]

  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={metricsData}>
        <PolarGrid strokeDasharray="3 3" />
        <PolarAngleAxis dataKey="name" tick={{ fill: "var(--foreground)", fontSize: 10 }} />
        <Radar
          name="Physical Measurements"
          dataKey="value"
          stroke="#10b981"
          fill="#10b981"
          fillOpacity={0.6}
          animationDuration={1000}
          animationEasing="ease-in-out"
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "var(--background)",
            borderColor: "var(--border)",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        />
        <Legend />
      </RadarChart>
    </ResponsiveContainer>
  )
}
